import React, { Component, PropTypes } from 'react';

import {
	TIMELINE_FETCH_NEXT,
	TIMELINE_FETCH_PREV,
} from '../constants/actions';

export default class InfiniteScrollTrigger extends Component {
	static propTypes = {
		callback: PropTypes.func.isRequired,
		browser: PropTypes.object.isRequired,
		contentTrigger: PropTypes.number.isRequired,
		direction: PropTypes.string
	};

	static defaultProps = {
		direction: TIMELINE_FETCH_NEXT,
		callback: () => {},
	};

	constructor(props) {
		super();
		this.DEBUG = false;
		this.scrollPos = 0;
	}

	componentDidMount() {
		let triggerElem = this.refs.trigger ||  this.triggerElem;

		this.deregisterScroll = this.handleScroll.bind(this);

		let scroll = this.props.browser.scroll;
		scroll && scroll.register(this.deregisterScroll);

		//this.saveInternalBounds(this.props);

		if (this.props.direction === TIMELINE_FETCH_PREV && triggerElem) {
			let scrollY = window.scrollY;
			window.scrollTo(0, scrollY + (triggerElem.offsetHeight));
		}
	}

	componentWillUnmount() {
		let scroll = this.props.browser.scroll;
		scroll && scroll.deregister(this.deregisterScroll);

		//console.log('unmounting - ' + this.props.direction);
	}

	componentWillReceiveProps(nextProps) {}

	//shouldComponentUpdate(nextProps, nextState) {
	//	return (
	//		(this.props.contentUpdate !== nextProps.contentUpdate) ||
	//		(this.props.browser.window.width !== nextProps.browser.window.width)
	//	);
	//}

	componentWillUpdate(nextProps, nextState) {
		//this.saveInternalBounds(nextProps);
	}

	componentDidUpdate() {
		//console.log(this.state.scrollPos);
	}

	render() {
		let triggerOffset = (
			this.props.contentTrigger + (
				(this.props.direction === TIMELINE_FETCH_NEXT) ? -Math.round(this.props.browser.window.height * 2) : Math.round(this.props.browser.window.height * 2)
			)
		);

		//console.log('%cTrigger: ' + triggerOffset, 'background: red; color: white;');

		let debugStyle = {
			display: 'block',
			width: '100%',
			position: 'absolute',
			top: triggerOffset + 'px',
			left: 0,
			borderTop: '1px solid ' + ((this.props.direction === TIMELINE_FETCH_NEXT) ? 'green' : 'red'),
		};

		let className = 'infinitescroll-trigger';
		let contClass = 'infinitescroll-trigger-cont';

		switch (this.props.direction) {
			case TIMELINE_FETCH_PREV:
				className += ' infinitescroll-trigger--prev';
				contClass += ' infinitescroll-trigger-cont--prev';
				break;
			case TIMELINE_FETCH_NEXT:
			default:
				className += ' infinitescroll-trigger--next';
				contClass += ' infinitescroll-trigger-cont--next';
				break;
		}

		if (this.props.manualTrigger) {
			contClass = '';
		}

		let styleAutoTrigger = this.props.manualTrigger ? {} : {height: (this.props.browser.window.height / 4) + 'px' };

		return (
			<div style={styleAutoTrigger} className={contClass}>
				{ this.DEBUG && <div style={debugStyle} className={this.props.direction}></div> }

				<div ref={'trigger'} className={className}>
					{(this.props.manualTrigger) && (
						<div onClick={this.props.callback} className='infinitescroll-trigger__clicker'>
							{this.getTriggerElement.bind(this)()}
						</div>
					)}
				</div>
			</div>
		);
	}

	getTriggerElement() {
		if (this.props.triggerElement) {
			return this.props.triggerElement;
		} else {
			return false;
		}
	}

	handleScroll(event) {
		let buffer = Math.round(this.props.browser.window.height * 2);
		let scrollBottom = event.scrollY + this.props.browser.window.height;

		if (this.props.direction === TIMELINE_FETCH_NEXT) {
			// Check if top-trigger is above window bottom
			//console.log(`${event.scrollY} > ${this.props.contentTrigger - buffer}`);
			if (event.scrollY > this.props.contentTrigger - buffer) {
				this.fetchNewContent();
			}
		}

		if (this.props.direction === TIMELINE_FETCH_PREV) {
			// Check if bottom-trigger is below window top
			if ((scrollBottom) < this.props.contentTrigger + buffer) {
				this.fetchNewContent();
			}
		}
	}

	// saveInternalBounds(props) {
	// 	let triggerElem = this.refs.trigger ||  this.triggerElem;
	//
	// 	if (triggerElem) {
	// 		this.offsets = {
	// 			top: triggerElem.offsetTop,
	// 			bottom: triggerElem.offsetTop + triggerElem.offsetHeight,
	// 		};
	//
	// 		//if (this.props.direction === TIMELINE_FETCH_NEXT) {
	// 		//	console.log(this.offsets.top);
	// 		//}
	// 	}
	//
	// 	//console.log('save bounds : ' + props.contentUpdate);
	// 	//console.log(this.offsets);
	// }

	fetchNewContent() {
		if ((!this.lastFetch || this.lastFetch !== this.props.contentUpdate) && !this.props.manualTrigger) {
			//console.log('trigger infinite content');
			this.props.callback();
			this.lastFetch = this.props.contentUpdate;
		}
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/utils/infiniteScrollTrigger.js
 **/